import { z } from 'zod';
import { MINECRAFT_ITEMS } from './minecraft-items.js';
export { MINECRAFT_ITEMS } from './minecraft-items.js';
export const GAME_MODES = ['survival', 'creative', 'adventure', 'spectator'];
export const gameModeSchema = z.enum(GAME_MODES);
export const playerPlatformSchema = z.enum(['java', 'bedrock']);
export const serverIdSchema = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z0-9-]+$/);
export const displayNameSchema = z.string().trim().min(1).max(40);
export const usernameSchema = z
    .string()
    .trim()
    .min(1)
    .max(16)
    .regex(/^[A-Za-z0-9_ ]+$/);
export const changeModeSchema = z.object({ mode: gameModeSchema });
export const whitelistMutationSchema = z.object({
    username: usernameSchema,
    platform: playerPlatformSchema,
});
export const teleportSchema = z
    .object({
    source: z.string().min(1).max(40),
    destination: z.string().min(1).max(40),
})
    .refine((value) => value.source !== value.destination, {
    message: 'Players must be different',
    path: ['destination'],
});
const minecraftItemIds = new Set(MINECRAFT_ITEMS.map((item) => item.id));
const hasControlCharacters = (value) => Array.from(value).some((character) => {
    const code = character.charCodeAt(0);
    return code < 32 || code === 127;
});
export const giveItemSchema = z.object({
    player: z.string().min(1).max(40),
    itemId: z.string().refine((value) => minecraftItemIds.has(value), {
        message: 'Unknown Minecraft item',
    }),
    amount: z.number().int().min(1).max(2304).default(64),
});
export const changePlayerModeSchema = z.object({
    player: z.string().min(1).max(40),
    mode: gameModeSchema,
});
export const killNearbyMobsSchema = z.object({
    player: z.string().min(1).max(40),
});
export const announcementSchema = z.object({
    text: z
        .string()
        .trim()
        .min(1, 'Announcement text is required')
        .max(120, 'Announcement must be 120 characters or fewer')
        .refine((value) => !hasControlCharacters(value), {
        message: 'Announcement must be a single line without control characters',
    }),
});
export const customCommandSchema = z.object({
    command: z
        .string()
        .trim()
        .min(1, 'Command is required')
        .max(512, 'Command must be 512 characters or fewer')
        .refine((value) => !hasControlCharacters(value), {
        message: 'Command must be a single line without control characters',
    })
        .transform((value) => (value.startsWith('/') ? value.slice(1).trim() : value))
        .refine((value) => value.length > 0, { message: 'Command is required' }),
});
// --- Agent ---
export const agentRoleSchema = z.enum(['user', 'assistant', 'tool']);
export const agentModelSchema = z.enum([
    'openai/gpt-5.6-luna',
    'qwen/qwen3.6-flash',
    'z-ai/glm-5.2',
    'google/gemini-3.5-flash',
    'anthropic/claude-haiku-4.5',
]);
export const agentMessageBodySchema = z.object({
    message: z.string().trim().min(1, 'Message is required').max(2000, 'Message is too long'),
    model: agentModelSchema.optional(),
});
export const agentSettingsBodySchema = z.object({ enabled: z.boolean() });
